import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useAutenticacao } from "@/contextos/AutenticacaoContexto";
import { ConteudoRegulamento } from "@/componentes/ConteudoRegulamento";

export default function Regulamento() {
  const { usuario } = useAutenticacao();
  const voltarPara = usuario ? "/dashboard" : "/";

  return (
    <div className="min-h-screen bg-superficie-base text-white">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-superficie-base/80 backdrop-blur-xl border-b border-white/5">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-4">
          <Link to={voltarPara} className="flex items-center gap-2 text-white/60 hover:text-white transition-colors">
            <ChevronLeft className="w-4 h-4" />
            Voltar
          </Link>
        </div>
      </header>

      {/* Conteúdo */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="mb-12">
          <h1 className="font-heading text-4xl md:text-5xl font-bold uppercase mb-2">Regulamento Oficial</h1>
          <p className="text-white/60">Bolão Copa do Mundo 2026</p>
        </div>

        <ConteudoRegulamento />

        <div className="mt-12 pt-8 border-t border-white/5">
          <Link
            to={voltarPara}
            className="inline-flex items-center gap-2 text-amarelobrasil hover:text-white transition-colors"
          >
            <ChevronLeft className="w-4 h-4" />
            Voltar ao início
          </Link>
        </div>
      </main>
    </div>
  );
}
